'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = require('./Alert');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});
Object.defineProperty(exports, 'PAGE_VARIANT', {
  enumerable: true,
  get: function get() {
    return _Alert.PAGE_VARIANT;
  }
});
Object.defineProperty(exports, 'INLINE_VARIANT', {
  enumerable: true,
  get: function get() {
    return _Alert.INLINE_VARIANT;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }